import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

/* ============== 通用审批流（manage 端） ============== */

// 审批流程配置 - 查询（businessKey 空=组织默认流程；传业务对象ID=该对象专属流程）
export const findApprovalFlowList = (businessType, businessKey) => {
  let url = `${baseUrl}/joins-sales-cloud/v1/approval/flow/list?businessType=${businessType || ''}`;
  if (businessKey) url += `&businessKey=${businessKey}`;
  return request({
    url,
    method: 'GET',
  });
};

// 审批流程配置 - 保存（整组替换 (businessType + 本组织 + businessKey)；按数组顺序生成第1级、第2级…）
// data: { businessType, businessKey, nodes: [{approverId, approverName}] }
export const saveApprovalFlow = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/flow/save`,
    method: 'POST',
    data,
  });
};

/* ============== 审批业务类型（菜单配置） ============== */

// 业务类型列表（直接返回数组，按创建时间升序）
export const findApprovalBusinessTypeList = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/businessType/list`,
    method: 'GET',
  });
};

// 保存业务类型（新增/编辑）{ typeCode, typeName, status }
export const saveApprovalBusinessType = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/businessType/save`,
    method: 'POST',
    data,
  });
};

// 删除业务类型（逻辑删除；不影响已配置流程）
export const deleteApprovalBusinessType = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/businessType/delete/${id}`,
    method: 'POST',
  });
};

// 我的待审批列表（当前节点轮到我审的单据）
export const findApprovalTodo = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/todo?` + params,
    method: 'GET',
  });
};

// 我的已审批列表（我通过/驳回过的）
export const findApprovalDone = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/done?` + params,
    method: 'GET',
  });
};

// 我发起的审批单
export const findApprovalMine = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/mine?` + params,
    method: 'GET',
  });
};

// 审批单详情（基本信息 + 节点进度 + 业务明细视图）
export const getApprovalDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/${id}`,
    method: 'GET',
  });
};

// 通过 / 驳回 { instanceId, action: APPROVE/REJECT, opinion }
export const auditApproval = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/audit`,
    method: 'POST',
    data,
  });
};

// 撤销 { instanceId, reason }（仅提交人、仅审批中）
export const cancelApproval = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/cancel`,
    method: 'POST',
    data,
  });
};

// 驳回后修改重提 { instanceId, applyData }（仅提交人、仅已驳回）
export const resubmitApproval = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/approval/resubmit`,
    method: 'POST',
    data,
  });
};
